export default __webpack_public_path__ + "static/media/speechAndDramaLight.2b4aa155.png";